module.exports = __webpack_public_path__ + "static/media/IndustryBanner.e546972f.png";